import type { PropsWithChildren } from 'react';
import { Suspense } from 'react';
import styled from 'styled-components';

import { lazy } from '#src/lib/retry.ts';

const ShaderWrapper = styled.div`
  position: absolute;
  inset: 0;
`;

const Shader = lazy(async () =>
  import('@sorare/trois/src/components/SnowBackground').then(module => ({
    default: module.SnowBackground,
  }))
);

export const SnowBackground = ({
  ...rest
}: PropsWithChildren<React.JSX.IntrinsicElements['div']>) => {
  return (
    <ShaderWrapper {...rest}>
      <Suspense fallback={null}>
        <Shader fallback={null} />
      </Suspense>
    </ShaderWrapper>
  );
};
